import { Component } from '../Component';
import { ArgSpecDictionary } from '../ComponentUtils';

import svgWideX from './WideX.svg?raw';

const DEBUG_VERBOSE: boolean = false;
export const HHDSButtonResidenceCloseTagName: string = 'hhds-button-residence-close';
const TAG_NAME: string = HHDSButtonResidenceCloseTagName;
const LOG_PREFIX: string = `[${TAG_NAME}]`;

export const HHDSButtonHeroAttrNames = {};

//const Attrs = HHDSButtonHeroAttrNames;

export class HHDSButtonResidenceClose extends Component {
	constructor() {
		super();
	}

	protected override init(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'init');
		const html: string = `<button class="${TAG_NAME}" mode="light">${svgWideX}</button>`;

		this.setInnerHtml('', '', html);

		this.observeSlotChanges(true);
	}

	protected override destroy(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'destroy');
	}

	override onAttributeChanged(name: string, _oldValue: string, _newValue: string): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onAttributeChanged: ${name}`);
		this.reinit();
	}

	override onSlotChange(_slot: HTMLSlotElement, _elements: HTMLElement[]): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onSlotChange`);
	}

	static override argSpecs(): ArgSpecDictionary {
		return ArgSpecs;
	}
}

export const ArgSpecs: ArgSpecDictionary = {};
